import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RequestService } from './services/requests.services';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.css']
})
export class RequestsComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private readonly route: ActivatedRoute, private readonly requestService: RequestService,
    private readonly router: Router) {
  }
  isautoLoaded = true;
  activeRequestCount = 0;
  activeCountSubscriber?: Subscription;
  currentTab: string = this.router.routerState.snapshot.url;
  ngOnInit() {
    if (this.router.routerState.snapshot.url === "/requests") {
      this.currentTab = "/openrequests";
      this.onNavigate('openrequests');
    }
  }
  onNavigate(navigation: string) {
    this.isautoLoaded = false;   
    this.router.navigate(['/' + navigation]);
  }
  ngAfterViewInit(): void {
    this.activeCountSubscriber = this.requestService.countEmitter.subscribe({
      next: (value) => {
        this.activeRequestCount = value;
      }
    });
  }
  ngOnDestroy(): void {    
    this.activeCountSubscriber?.unsubscribe();    
  }
}
